import {ExternalLink} from '../social-sharing/externalLink';
import {JsonObject, JsonProperty} from 'json2typescript';
import {ExternalLinkConverter} from '../../customJsonConverters/ExternalLinkConverter';

@JsonObject('EmailImage')
export class EmailImage {

    @JsonProperty('questionNo',Number,true)
    questionNo = 0;

    @JsonProperty('choiceNo',Number,true)
    choiceNo = 1;

    @JsonProperty('tag',String,true)
    tag = '';

    @JsonProperty('uid',String,true)
    uid = '';

    @JsonProperty('linkToUrl',Boolean,true)
    linkToUrl = false;

    @JsonProperty('linkToMicrosite',Boolean,true)
    linkToMicrosite = false;

    @JsonProperty('externalLink',ExternalLinkConverter)
    externalLink = new ExternalLink();

    @JsonProperty('cssClass',String,true)
    cssClass = '';

    constructor() {
    }

}
